import { useEffect, useRef } from "react";
import { LoadInitialValuePluginRef } from "libs/components/src/components/AscRichTextEditor/plugins/LoadInitialValuePlugin/LoadInitialValuePlugin";

type Props = {
  textData: string;
};

//Provides external logic handling for Rich Text Editor - Lexical

//Auto updates/resets editor on initial value change
//Current version of hook is focused on inferString prop
export const useRichEditor = ({ textData }: Props) => {
  const editorRef = useRef<LoadInitialValuePluginRef>(null);
  useEffect(() => {
    editorRef.current?.reset({
      inferString: textData,
    });
  }, [textData]);
  return editorRef;
};
